'use strict';
import React from 'react';
import modalAction from '../../actions/modalAction';
import leaveAtdStore from '../../stores/leaveAtdStore';
import leaveAtdAction from '../../actions/leaveAtdAction';
import userStore from '../../stores/userStore';
import genFunction from '../../functions/genFunction';

class AtdStaffApply extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,
            isAtdSuccess: leaveAtdStore.getState().isAtdSuccess,
            staffId: leaveAtdStore.getState().staffId,
            date: "",
            startTime: "",
            startLocation: "",
            startRemark: "",
            endTime: "",
            endLocation: "",
            endRemark: "",

        }
    }

    componentDidMount() {
        leaveAtdStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
    }
    componentWillUnmount() {
        leaveAtdStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isAtdSuccess && prevState.isAtdSuccess != this.state.isAtdSuccess) {
            window.setTimeout(() => {
                window.location.reload();
            }, 3000);
        }
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            staffId: state.staffId,
            isAtdSuccess: state.isAtdSuccess,
        });
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId,
        });
    }
    handleChange(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (index == 0) {
            leaveAtdAction.staffId(e.target.value);
        } else if (index == 1) {
            this.setState({
                date: e.target.value
            });
        } else if (index == 2) {
            this.setState({
                startTime: e.target.value
            });
        } else if (index == 3) {
            this.setState({
                startLocation: e.target.value
            });
        } else if (index == 4) {
            this.setState({
                startRemark: e.target.value
            });
        } else if (index == 5) {
            this.setState({
                endTime: e.target.value
            });
        } else if (index == 6) {
            this.setState({
                endLocation: e.target.value
            });
        } else if (index == 7) {
            this.setState({
                endRemark: e.target.value
            });
        }

    }

    handleSubmit(e) {
        let s = this.state;
        let sDate = s.date;
        let date, month, year, startTime, endTime;

        if (sDate == "") {
            modalAction.modalContent({ title: "Warning", content: "Please select Date" });
            modalAction.modalClose(true);
            return;
        } else if (s.startTime == "" || s.endTime == "") {
            modalAction.modalContent({ title: "Warning", content: "Please Start Time and End Time cannot be empty" });
            modalAction.modalClose(true);
            return;
        } else if (s.staffId == "") {
            modalAction.modalContent({ title: "Warning", content: "Please select Staff" });
            modalAction.modalClose(true);
            return;
        }
        date = parseInt(sDate.split("-")[2]);
        month = parseInt(sDate.split("-")[1]) - 1;
        year = parseInt(sDate.split("-")[0]);

        startTime = new Date(year, month, date, s.startTime.split(":")[0], s.startTime.split(":")[1]);
        endTime = new Date(year, month, date, s.endTime.split(":")[0], s.endTime.split(":")[1]);

        if (endTime.getTime() < startTime.getTime()) {
            modalAction.modalContent({ title: "Warning", content: "End Time must be greater than Start Time" });
            modalAction.modalClose(true);
            return;
        }

        if (!this.props.processing) {
            leaveAtdAction.processing(true);
            leaveAtdAction.markAttendate(s.staffId, year, month, date, startTime, s.startLocation,
                s.startRemark, endTime, s.endLocation, s.endRemark);
        }
    }
    renderStaffs() {
        let staffs = this.props.staffs;
        if (staffs.length > 0) {
            staffs = this.props.staffs.filter((staff) => {
                return ((genFunction.hasPermission(this.state.permission, 11) && this.state.userId != staff.staffId) ||
                    (genFunction.isSubordinate(this.state.subordinate, staff.staffId) && this.state.userId != staff.staffId)
                );
            });

            return staffs.map((staff, index) => {
                return (
                    this.renderStaff(staff, index)
                );
            });
        }
    }
    renderStaff(staff, index) {
        return (<option value={staff.staffId} key={index}>{staff.userName}</option>);
    }
    render() {
        let s = this.state;
        let today = new Date();
        let max = today.getFullYear() + "-" + (today.getMonth() + 1 < 10 ? "0" + (today.getMonth() + 1) : today.getMonth() + 1) + "-" +
            (today.getDate() < 10 ? "0" + today.getDate() : today.getDate());
        return (
            <div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="staffName">Staff Name: </label>
                            <select className="form-control atd-sel" id="staffName" name="staffName" data-index="0"
                                onChange={this.handleChange} value={s.staffId}>
                                <option value="" ></option>
                                {this.renderStaffs()}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <input className="form-control atd-sel" type="date" name="date" data-index="1"
                                onChange={this.handleChange} value={s.date} disabled={s.staffId == ""} max={max} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="startTime">Start Time</label>
                            <input className="form-control atd-sel" type="time" name="startTime" data-index="2"
                                onChange={this.handleChange} value={s.startTime} disabled={s.staffId == ""} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="startLocation">Start Location</label>
                            <input className="form-control atd-sel" type="text" name="startLocation" data-index="3"
                                onChange={this.handleChange} value={s.startLocation} disabled={s.staffId == ""} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="date">Start Remark</label>
                            <input className="form-control atd-sel" type="text" name="startRemark" data-index="4"
                                onChange={this.handleChange} value={s.startRemark} disabled={s.staffId == ""} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="endTime">End Time</label>
                            <input className="form-control atd-sel" type="time" name="endTime" data-index="5"
                                onChange={this.handleChange} value={s.endTime} disabled={s.staffId == ""} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="endLocation">End Location</label>
                            <input className="form-control atd-sel" type="text" name="endLocation" data-index="6"
                                onChange={this.handleChange} value={s.endLocation} disabled={s.staffId == ""} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="endRemark">End Remark</label>
                            <input className="form-control atd-sel" type="text" name="endRemark" data-index="7"
                                onChange={this.handleChange} value={s.endRemark} disabled={s.staffId == ""} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <button className="btn btn-default" onClick={this.handleSubmit}>Apply</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default AtdStaffApply;


// WEBPACK FOOTER //
// ./app/components/leaveAtdComponents/atdStaffApply.js